<template>
  <div class="flex w-full justify-end items-end px-2 py-2">
    <div>
      <el-dropdown>
        <el-button size="small">
          Options
          <el-icon class="el-icon--right">
            <ChevronDownIcon class="w-4 " />
          </el-icon>
        </el-button>
        <template #dropdown>
          <el-dropdown-menu>
            <el-dropdown-item @click="handleClickCreateNewEvent">
              <PlusIcon class="w-5 text-untitled-gray-600 mr-2" />
              <span class="text-xs font-semibold text-untitled-gray-600"
                >Create Reminder</span
              >
            </el-dropdown-item>
            <el-dropdown-item @click="handleClickViewAllEvents">
              <EyeIcon class="w-5 text-untitled-gray-600 mr-2" />
              <span class="text-xs font-semibold text-untitled-gray-600"
                >View All Reminders</span
              >
            </el-dropdown-item>
          </el-dropdown-menu>
        </template>
      </el-dropdown>
    </div>
  </div>
  <create-reminder
    v-if="openCreateReminderModal"
    @changeCompany="handleOnChangeCompany"
    @changeDealer="handleOnChangeDealer"
    :isOpen="openCreateReminderModal"
    :handleCloseModal="closeModal"
    :users="users"
    eventBusName="NEW_REMINDER_HOMEPAGE"
  />
</template>

<script setup>
import {
  ChevronDownIcon,
  // FilmIcon,
  PlusIcon,
  EyeIcon,
} from "@heroicons/vue/outline";
import {
  ElDropdown,
  ElDropdownItem,
  ElDropdownMenu,
  ElButton,
  ElIcon,
} from "element-plus";
import CreateReminder from "@/components/reminders/CreateReminderForm/CreateReminder";
import { ref, watch } from "vue";
import { useUsersStore } from "@/stores/useUser.store";
import { storeToRefs } from "pinia";
import { useRouter } from "vue-router";
import { useDialogStore } from "@/stores/useDialogStore";

const dialogStore = useDialogStore();
const router = useRouter();
const usersStore = useUsersStore();
const { selectedCompanyIds, selectedDealerIds, users } =
  storeToRefs(usersStore);

const openCreateReminderModal = ref(false);

const handleClickCreateNewEvent = () => {
  openCreateReminderModal.value = true;
  usersStore.handleFetchUsers();
};

const handleClickViewAllEvents = () => {
  router.push({ name: "reminders" });
};

const closeModal = () => {
  openCreateReminderModal.value = false;
};

const handleOnChangeCompany = (companiesId) => {
  selectedCompanyIds.value = companiesId;
};

const handleOnChangeDealer = (dealersId) => {
  selectedDealerIds.value = dealersId;
};

watch([selectedCompanyIds, selectedDealerIds], () => {
  usersStore.handleFetchUsers();
});

watch(openCreateReminderModal, (value) => {
  if (value) {
    dialogStore.zIndexValue = 0;
  } else {
    dialogStore.zIndexValue = 40;
  }

  dialogStore.isDialogVisible = value;
});
</script>

<style lang="scss" scoped></style>
